var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1496.71,
    height: 1452.882,
    viewBox: "0 0 1496.71 1452.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5494",
    "data-name": "Group 5494",
    transform: "matrix(-0.985, 0.174, -0.174, -0.985, 2331.376, 1831.386)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M1059.9,1148.036c-.69-17.991-8.337-34.862-13.272-52.175s-6.834-37.155,2.954-52.264c5.292-8.17,13.506-14.107,18.857-22.239,12.462-18.942,6.866-45.136,17.4-65.217,8.851-16.874,30.255-26.7,48.313-20.614s29.175,28.65,21.4,46.049c-7.228,16.182-26.394,23.828-35.6,38.974-9.677,15.927-6.177,36.875,2.446,53.4s21.7,30.241,32,45.773,17.953,34.451,13.655,52.584c-1.7,7.181-5.45,14.127-11.523,18.319-14.732,10.171-35.995-.367-45.216-15.708-3.315-5.518-6.039-11.949-11.678-15.053-8.655-4.764-20.01,1.247-24.725,9.929s-4.706,19.042-5.039,28.917c-.574,17.074-2.791,34.885-12.419,49s-28.639,23.1-44.35,16.392c-16.175-6.909-22.564-28.729-15.482-44.828C1012.912,1184.521,1061.775,1196.845,1059.9,1148.036Z",
    transform: "translate(250.399 190.608)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M1095.621,1101.238c4.109-1.345,7.2-4.984,8.651-9.054,2.587-7.242.452-15.387-3.156-22.178s-8.615-12.753-12.328-19.487c-5.249-9.521-7.831-20.44-13.957-29.422s-17.862-15.779-27.781-11.329c-6.338,2.841-10.238,9.755-10.752,16.684-.933,12.58,8.648,19.669,11.09,30.878,2.01,9.23-2.208,13.049,6.972,18.665,7.012,4.286,17.615,2.05,23.884,7.989C1084.355,1089.768,1082.648,1105.486,1095.621,1101.238Z",
    transform: "translate(284.225 251.495)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M1047.765,1030.151a16.448,16.448,0,0,1-.38-2.963c-.114-3.364.868-6.781,3.895-7.789C1062.361,1015.727,1053.506,1055.9,1047.765,1030.151Z",
    transform: "translate(293.312 260.298)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M1027.738,1105.7c1.894,20.587,11.438,41.428,5.307,61.173-5.648,18.191-22.9,29.778-35.181,44.337a94.245,94.245,0,0,0-18.9,82.824c2.34,9.1,6.247,18.087,13.063,24.552,9.612,9.116,23.5,11.94,36.692,13.176,12.321,1.155,25.324,1.14,36.328-4.515,26.023-13.378,28.8-50.116,49.176-71.114,22.706-23.4,61.083-21.84,88.522-39.451a71.643,71.643,0,0,0,11.594-111.324c-5.04-4.968-10.821-9.194-15.384-14.6-11.188-13.252-13.474-33.34-5.554-48.767,3.506-6.829,8.726-12.637,12.5-19.318,7.736-13.684,8.931-30.166,7.495-45.821-1.3-14.178-4.708-28.4-12.023-40.608s-18.87-22.283-32.663-25.816c-19.939-5.106-41.351,4.192-56.048,18.6-13.748,13.477-22.63,30.769-31.062,47.836-6.781,13.728-8.045,26.183-12.589,40.138-5.078,15.6-21.194,24.406-29.546,38.279C1029.878,1071.2,1027.738,1087.536,1027.738,1105.7Z",
    transform: "translate(235.219 170.458)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M1015.118,1155.927c-3.319,11.849-12.007,21.281-19.623,30.945a215.249,215.249,0,0,0-45.156,146.9c1.489,20.943,6.5,42.507,19.859,58.7,17.029,20.632,44.733,29.18,71.3,32.292,25.922,3.036,54.134,1.285,75.03-14.351,27.708-20.736,34.956-59.554,58.524-84.9,21.789-23.429,54.661-32.534,81.083-50.574,36.764-25.1,60.078-68.815,60.444-113.329.08-9.548-.955-19.491-5.943-27.634-4.479-7.313-11.683-12.444-17.826-18.428a82,82,0,0,1-23.726-68.009c1.729-13.526,6.843-26.368,9.857-39.668,4.67-20.611,4.123-42.7-3.718-62.328s-23.374-36.5-43.152-43.942c-20.026-7.538-42.812-5.022-62.637,3.034s-37.113,21.252-53.324,35.217c-17.521,15.091-32.011,31.149-41.991,52.182-8.6,18.125-16.446,35.768-27.712,52.448-8.844,13.092-16.9,25.907-22.853,40.637-4.565,11.284-7.965,21.905-7.936,34.168S1018.5,1143.851,1015.118,1155.927Z",
    transform: "translate(213.745 160.737)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M1079.429,1024.645c-24.344,23.759-49.759,49.343-57.771,82.4-3.128,12.905-3.671,27.062-11.471,37.812s-21.1,15.66-32.933,21.711c-37.9,19.385-66.3,56.422-75.184,98.056-.926,4.345-1.4,9.543,1.834,12.584,3.905,3.671,10.131,1.647,15.482,1.327,11.778-.7,22.385,8.535,26.818,19.469s3.94,23.189,2.752,34.929c-3.007,29.727-9.9,60.534-.327,88.838,11.075,32.735,43.2,55.334,77.094,62.07s69.189-.316,101.634-12.212c37.113-13.606,74.495-36.539,88.03-73.679,4.172-11.446,5.968-23.984,12.724-34.123,5.445-8.172,13.639-14.042,21.646-19.723l54.154-38.427c21.335-15.137,43.139-30.748,57.833-52.389,12.279-18.087,18.913-39.526,22.145-61.148,4.348-29.1,1.6-61.887-18.864-83.021-9.527-9.835-22.615-16.9-28.264-29.371-10.347-22.853,9.454-47.035,17.141-70.916,6.012-18.675,4.358-39.359-2.694-57.667-19.467-50.541-82.383-78.885-133.629-61.351-17.145,5.868-32.552,15.93-46.917,26.976a360.607,360.607,0,0,0-78.886,83.909Z",
    transform: "translate(174.236 150.558)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M925.517,1095.281c-3.951,4.467-8.007,9.18-9.5,14.953s.436,12.9,5.854,15.4c7.38,3.393,16.981-3.067,23.841,1.286a12.728,12.728,0,0,1,4.138,4.762c8.012,14.628-1.451,32.358-2.086,49.023-.138,3.631,1.06,8.294,4.672,8.686,3.41.37,5.621-3.459,6.645-6.73,4.784-15.269,4.4-31.789,9.2-47.053,5.323-16.936,16.553-30.914,27.205-44.778,8.31-10.814,23.763-27.474,11.1-40.73C982.663,1025.066,939.147,1079.872,925.517,1095.281Z",
    transform: "translate(185.77 280.269)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M935.56,1080.521c-2.809,4.419-4.261,10-2.614,14.966s7,8.818,12.1,7.642c7.237-1.667,9.285-10.741,13.6-16.785,4.388-6.146,22.052-21.386,6.38-27C955.519,1055.934,940.139,1073.316,935.56,1080.521Z",
    transform: "translate(199.415 292.714)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M1016.406,1149.651c-8.947-4.141-17.978-9.187-27.837-9.2s-20.593,7.475-19.816,17.3c.628,7.963,8.163,13.534,15.522,16.64s15.563,5.093,21.223,10.73c3.947,3.931,6.228,9.261,10.028,13.334,5.336,5.717,13.109,8.4,20.651,10.476,7,1.921,14.458,3.491,21.43,1.485s13.094-8.742,11.965-15.908a46.931,46.931,0,0,0,32.833-21.949c5.536-9.229-1.73-16.562-11.524-16.326-6.084.147-10.066,4.691-15.605,6.324C1057.477,1167.813,1032.429,1157.068,1016.406,1149.651Z",
    transform: "translate(229.154 359.228)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M1002.573,1152.595c-4.811-1.236-10.845-2.1-13.924,1.8-2.052,2.6-1.785,6.469-.178,9.361s4.308,5,7.019,6.9a108.381,108.381,0,0,0,24.22,12.722c10.187,3.8,30.266.232,23.688-15.427C1038.668,1156.678,1012.782,1155.219,1002.573,1152.595Z",
    transform: "translate(244.221 368.28)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M1084.7,1038.246c-9.786,20.052-12.092,43.865-25.871,61.415-9.209,11.729-22.539,19.311-34.8,27.792a241.327,241.327,0,0,0-82.338,98.9c-9.832,21.854-15.607,49.573-.487,68.163,9.249,11.369,24.867,17.089,31.659,30.078,3.5,6.687,4.145,14.447,4.73,21.971l2.295,29.62c1.825,23.554,3.508,48.1-5.351,70s-31.7,40.087-54.86,35.421c-5.372-1.084-10.719-3.5-14.009-7.882-4.2-5.592-4.3-13.181-3.862-20.162,1.576-25.293,7.5-52.224-3.835-74.89-6.126-12.252-16.624-21.62-26.061-31.548A237.9,237.9,0,0,1,808.147,1207.9c-2.8-28.184.227-58.7,17.789-80.924a73.591,73.591,0,0,1,62.039-27.269c7.38.545,14.855,2.217,22.1.69,10.63-2.239,18.8-11.088,23.572-20.849s6.794-20.587,9.8-31.027c5.71-19.826,15.022-38.444,25.526-56.2,11.872-20.072,25.591-39.486,43.8-54.054s41.472-23.95,64.687-21.729c6.424.614,14.283,3.873,14.185,10.324-.1,6.484-8.514,10.4-8.862,16.878-.421,7.774,10.525,10.732,17.956,8.408,11.62-3.635,24.594-10.941,31.7,3.655,3.853,7.907,2.631,20.718-1.647,28.294C1119.214,1004.617,1095.638,1015.843,1084.7,1038.246Z",
    transform: "translate(97.451 176.334)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M977.981,974.627c-11.146,21.27-16.475,45.029-24.879,67.525s-20.927,44.864-41.6,57.074c-14.961,8.833-33.119,11.682-47.1,21.991a74.789,74.789,0,0,0-16.028,16.972c-23.774,33.211-30.061,78.246-16.292,116.7,7.29,20.355,22.7,40.545,44.221,42.567,7.923.744,16.393-1.338,22.062-6.923,8.455-8.332,8.711-21.7,7.972-33.543-1.609-25.8-5.254-52.05.579-77.232,10.164-43.865,46.79-76.087,82.97-102.891,19.465-14.419,41.016-30.667,45.134-54.539,1.432-8.308.96-17.893,7-23.779,2.695-2.625,6.311-4.052,9.387-6.215,25.9-18.218-3.806-41.434-19.761-50.548C1007.688,928.1,988.328,954.878,977.981,974.627Z",
    transform: "translate(111.84 194.136)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M907.446,1028.448c2.941,4.586,9.9,5.175,14.583,2.388s7.4-7.985,9.009-13.19c3.6-11.68,5.38-21.426,14.272-30.47,3.524-3.584,16.633-9.12,17.855-13.946,2.09-8.254-11.54-10.594-17.4-11.462-9.6-1.422-23.352-1.151-29.489,7.733-5.135,7.433-3.918,20.044-5.127,28.569C910.01,1006.105,902.664,1020.991,907.446,1028.448Z",
    transform: "translate(177.877 212.963)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M835.557,1153.768c.383,10.509,3.1,22.592,12.528,27.252,8.788,4.346,20.093-.34,25.573-8.468s6.153-18.645,4.762-28.351-4.631-19.055-6.353-28.708c-2.437-13.672-1.563-28.518,5.754-40.323,5.2-8.392,31.6-23.178,23.129-33.38-9.336-11.246-27.6,13.325-33.178,20.043C846.607,1087.333,834.344,1120.511,835.557,1153.768Z",
    transform: "translate(120.482 276.387)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M842.455,1108.169c-.8,4.25-1.525,8.628-.7,12.873s3.524,8.39,7.638,9.721c5.2,1.68,11.083-1.848,13.307-6.839s1.407-10.886-.75-15.906a39.923,39.923,0,0,1-2.422-5.979,41.647,41.647,0,0,1-.683-5.606c-.541-5.042-2.834-16.333-9.837-13.71C844.917,1084.252,843.214,1104.125,842.455,1108.169Z",
    transform: "translate(125.307 311.822)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M858.571,1173.991c2.346,5.309,8.343,7.787,12.653,11.673,9.663,8.711,10.055,23.7,7.809,36.512s-6.391,25.929-3.244,38.553a12.4,12.4,0,0,0,3.114,6.169,13.318,13.318,0,0,0,4.27,2.462c6.162,2.495,13.034,3.92,19.472,2.271s12.235-6.965,12.885-13.581c.363-3.688-.832-7.321-1.63-10.939-2.87-13.02-.637-26.568,1.857-39.664s5.262-26.452,3.424-39.656c-2.331-16.744-11.812-31.915-29.658-25.675C878.686,1145.906,851.86,1158.807,858.571,1173.991Z",
    transform: "translate(138.452 359.415)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M883.849,1194.286c-.356,2.622-1.126,5.338-.31,7.856s4.181,4.379,6.155,2.614c2.075-3.569,4.2-7.284,4.59-11.395.715-7.482-4.425-18.8-6.943-25.825-2.162-6.035,2.057-8.836-7.473-7.437C861.933,1162.733,885.38,1182.968,883.849,1194.286Z",
    transform: "translate(151.153 374.962)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M987.066,800.855c-7.337,6.337-14.469,13.281-18.706,22-4.821,9.919-5.5,21.27-6.1,32.283-.156,2.892-.283,5.935,1.017,8.523,2.306,4.592,8.2,6.06,13.33,5.877,7.114-.252,13.989-2.656,21.083-3.243s15.13,1.195,19.015,7.159c1.877,2.883,2.544,6.38,4.056,9.472,5.151,10.527,21.188,13.508,29.78,5.536,19.541-18.134-3.063-49.537,23.405-66.279,18.114-11.457,38.669-8.844,38.293-36.608C1111.344,719.57,1008.858,782.041,987.066,800.855Z",
    transform: "translate(223.813 45.677)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M1201.385,822.048c.716,17.266,18.863,27.345,32.271,38.246,33.24,27.027,44.2,74.209,39.07,116.742s-23.781,82.042-40.782,121.366c-6.44,14.9-12.806,31.061-9.412,46.932,3.746,17.519,20.451,31.374,38.359,31.813,15.681.387,30.426-8.548,40.748-20.357s16.947-26.319,23.429-40.6l26.7-58.853c3.121-6.876,6.373-13.94,11.878-19.107,7.161-6.718,17.114-9.325,25.989-13.526,42.752-20.233,57.29-74.883,94.762-103.742,17.424-13.417,39.366-20.847,54.577-36.73,18.12-18.919,23.627-47.244,20.337-73.233s-9.091-53.6-25.635-73.915c-38.671-47.473-109.748,9.512-114.688,30.272-5.716,24.022-15.772,116.448-60.167,89.361-30.2-18.429-40.225-53.486-78.3-62.893C1257.139,788.042,1199.815,784.093,1201.385,822.048Z",
    transform: "translate(418.897 15.227)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M1593.324,983.558c-43.869,44.194-73.011,101.2-92.653,160.3-18.348,55.2-30.344,115.438-69.563,158.4-41.672,45.645-108.552,64.914-143.2,116.1-27.881,41.187-30.17,96.885-62.65,134.553-25.4,29.457-64.658,42.422-102.366,51.954s-77.223,17.511-108.539,40.581-51.643,66.716-34.713,101.734c13.835,28.614,46.572,41.992,76.778,51.878,67.174,21.983,104.59,53.829,175.214,51.026,92.249-3.66,80.982-49.957,86.483-59.777a999.522,999.522,0,0,0,76.343-172.775c14.049-42.209,26.1-86.884,55.5-120.273,27.793-31.566,67.659-49.112,104.579-69.257a683.012,683.012,0,0,0,120.991-84.146c26.069-22.677,50.755-47.789,67.192-78.18,17.733-32.786,25.025-70.088,30.844-106.905,1.767-11.192,3.412-22.728.8-33.752-12.088-51.159-97.849-50.788-114.761-100.561-8.181-24.079,4.779-51.489,25.016-66.889s68,17.09,71.415-24.122S1637.192,939.364,1593.324,983.558Z",
    transform: "translate(233.076 177.448)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M1474.751,1086.771c-7.226,21.9-10.433,44.953-17.281,66.976-37.236,119.767-170.354,183.683-228.865,294.619-14.331,27.171-24.276,57.322-44.862,80.121-15.556,17.232-36.127,29.015-56.607,39.947-20.565,10.979-41.9,21.765-57.633,38.974-22.742,24.883-29.478,66.865-6.941,91.935,18.9,21.018,52.675,23.674,78.253,11.651s43.825-35.854,56.3-61.213,20.13-52.783,30.8-78.952c23-56.4,59.61-106.021,95.843-154.98,16.646-22.494,33.465-45.178,54.508-63.623,19.661-17.236,42.516-30.335,64.661-44.236a964.115,964.115,0,0,0,154.8-120.784c17.3-16.595,34.29-34.284,44.406-56.013,28.6-61.435-19.983-93.736-68.367-118.536C1521.505,985.867,1489.6,1041.758,1474.751,1086.771Z",
    transform: "translate(294.368 249.306)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M1270.479,1225.391c1.233,12.891,22.7,3.664,31.16-3.864s12.985-18.421,17.065-28.985,8.2-21.535,16.143-29.6c13.014-13.214,33-15.7,50.541-21.735a118.624,118.624,0,0,0,51.678-35.37c41.868-49.521-45.341-88.81-80.317-57.96C1343.682,1059.4,1269.244,1212.5,1270.479,1225.391Z",
    transform: "translate(475.264 274.809)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M1087.144,1413.911c-15.331-2.477-3.633-26.868.283-39.786s10.56-24.812,17.15-36.592c1.938-3.462,4-7.063,7.324-9.229a23.988,23.988,0,0,1,7.7-2.818q11.509-2.726,23.165-4.768a5.272,5.272,0,0,1,3.715.267,5.118,5.118,0,0,1,1.819,3.05c8.107,27,6.171,76.5-17.615,89.254S1102.475,1416.387,1087.144,1413.911Z",
    transform: "translate(319.482 506.088)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M997.267,1372.266c4.279-13.7,12.809-27.537,26.446-32.009a8.1,8.1,0,0,1,3.967-.5c3.4.635,4.928,4.477,7.077,7.181,5.294,6.656,15.741,6.716,23.416,3.05s13.579-10.122,20.3-15.335,45.152-33.52,51.024-24.249-25.729,30.831-29.246,36.474c-2.665,4.274-7.318,6.794-11.534,9.552-25.3,16.554-10.383,94.524-18.556,103.858S973.43,1448.543,997.267,1372.266Z",
    transform: "translate(249.13 496.329)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M1477.688,1204.519c-25.754,0-64.115,39.148-96.173,58.722-9.365,5.719-18.938,11.618-25.745,20.228-11.958,15.126-13.388,36.258-9.83,55.209,3.333,17.759,10.58,35.5,7.46,53.3-3.511,20.026-19.2,35.238-31.769,51.213a195.607,195.607,0,0,0-40.445,98.731c-1.409,12.656-.548,27.634,9.851,34.987,9.091,6.425,22.281,3.883,30.953-3.1s13.751-17.406,18.058-27.674c16.177-38.554,25.811-80.834,51.5-113.826,16.62-21.348,38.932-37.389,59.035-55.5s38.849-39.773,44.564-66.217C1500.592,1285.392,1503.444,1204.519,1477.688,1204.519Z",
    transform: "translate(483.583 411.479)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M1413.266,1231.163c-7.427,0-35.887,25.219-53.833,37.828-4.39,3.086-8.822,6.206-12.424,10.184-12.544,13.846-12.561,34.6-11.864,53.266.156,4.211.45,8.781,3.216,11.961,2.266,2.607,5.819,3.759,9.263,4.016,11.228.842,21.989-5.906,29.387-14.392C1442,1259.486,1420.7,1231.163,1413.266,1231.163Z",
    transform: "translate(527.824 433.211)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M1223.521,1319.218c-1.006,6.473-.153,14.77,5.97,17.1,4.28,1.629,9.142-.722,12.321-4.018s5.289-7.479,8.3-10.926a27.585,27.585,0,0,1,27.4-8.279c2.257.614,4.519,1.532,6.847,1.3,5.986-.594,8.591-8.014,8.392-14.027-.494-14.861-9.465-28.976-7.457-43.707.615-4.517,2.155-9.534-.383-13.319-2.342-3.493-7.215-4.245-11.377-3.649-19.8,2.831-17.134,19-23.917,32C1240.582,1289.008,1226.827,1297.937,1223.521,1319.218Z",
    transform: "translate(436.685 440.017)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M1052.184,1544.938c58.448-22.523,11.1-98.98,43.4-136.191s75.88-62.818,120.535-83.649c28.309-13.2,144.257-56.229,126.931-77.483s-249.574,137.843-359.1,139.887c-28.46.53-56.52-6.111-84.864-8.724s-58.653-.679-82.358,15.077c-9.953,6.616-18.314,15.418-25.428,25.023-13.661,18.443-23.111,41.247-20.417,64.04s22.416,39.214,50.485,61.112S993.738,1567.461,1052.184,1544.938Z",
    transform: "translate(67.427 445.036)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M829.141,1456.461c-26.4-4.052-19.454-30.354-24.946-47.453-5.175-16.112-7.048-35.57,4.067-48.33,6.758-7.758,17.007-11.4,26.936-14.094,3.713-1.006,7.64-1.925,11.368-.971,8.746,2.237,11.767,12.847,13.628,21.682,2.633,12.5,6.193,25.319,14.47,35.052s22.468,15.509,34.221,10.5c12.081-5.156,17.346-18.939,23.815-30.37,15.769-27.873,61.2-56.573,77.643-50.036s-6.823,40.6-20.91,56.364,19.162,55.378-.035,67.661S855.545,1460.513,829.141,1456.461Z",
    transform: "translate(91.623 515.044)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M774.558,1306.555c-7,19.983-21.413,37.4-24.447,58.354-.939,6.478.861,15.084,7.34,16,4.042.572,7.834-2.522,9.639-6.182s2.15-7.838,2.918-11.847a55.306,55.306,0,0,1,14.423-27.823c6.827-7.075,15.407-12.181,22.893-18.555s14.165-14.716,15-24.513c1.38-16.212-12.993-28.93-25.981-38.736-3.736-2.82-13.938-10.787-19.078-7.662-5.539,3.368-.465,11.546.516,16.7A86.1,86.1,0,0,1,774.558,1306.555Z",
    transform: "translate(50.669 444.396)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M802.1,969.979c-2.2,7.237,4.192,14.249,10.774,17.98,2.518,1.429,5.252,2.736,6.961,5.075,1.542,2.112,2.07,4.848,3.689,6.9a8.165,8.165,0,0,0,8.5,2.709c6.734-1.981,8.72-11.133,13.29-15.718,5.042-5.058,11.03-3.043,6.712-10.906C847.491,967.75,804.1,963.412,802.1,969.979Z",
    transform: "translate(92.904 217.584)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M864.176,905.616c-6.6,18.882-6.351,40.06-15.783,57.7-9.993,18.69-29.34,30.568-41.343,48.036-3.125,4.546-5.79,9.664-6.039,15.175s2.462,11.445,7.544,13.592c6.823,2.88,14.741-2.1,18.418-8.53s4.539-14.031,6.847-21.066c11.464-34.931,56.544-51.994,63.837-88.024,1.819-8.989,1.06-18.59,4.69-27.011,5.679-13.17,19.551-19.124,30.186-27.494,8.375-6.592,24.7-28.011,2.05-26.61C905.663,843.174,872.907,880.635,864.176,905.616Z",
    transform: "translate(92.361 115.249)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M834.336,799.668c-6.1,4.773-10.719,11.137-15.255,17.414-6.518,9.02-13.12,18.194-16.88,28.667-3.593,10.011-4.432,20.791-4.635,31.425a281.62,281.62,0,0,0,.955,29.184c.236,2.783,1.158,6.28,3.929,6.647a5.376,5.376,0,0,0,3.283-.91c9.321-5.336,11.838-17.473,12.726-28.176s1.587-22.586,9.289-30.072c13.681-13.294,39.426-3.571,53.622-16.315,11.611-10.422,6.456-31.82-4.272-41.418C865.873,786.075,845.015,791.309,834.336,799.668Z",
    transform: "translate(89.521 73.896)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M1036.755,772.681c-14.71,6.084-29.164,13.27-41.334,23.532s-21.985,23.882-25.406,39.43c-.648,2.938-.939,6.375,1.084,8.6a7.693,7.693,0,0,0,5.441,2.135c9.813.4,18.24-9.047,27.995-7.916,9.423,1.095,14.656,11.075,19.1,19.456,1.347,2.538,3.132,5.309,5.97,5.77,5.463.89,7.765-6.7,7.825-12.232l.3-27.067c.116-10.774,1.095-23.265,9.957-29.395,7.529-5.207,41.323-6.687,32.579-24.193C1073.234,756.728,1045.815,768.934,1036.755,772.681Z",
    transform: "translate(229.821 52.344)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M984.216,809.6c2.856,2.044,6.932.866,9.788-1.18,4.782-3.426,6.8-6.691,12.531-6.287,2.506.176,1.106,6.026,6.473,5.189,8.771-1.367,5.933-13.717,1.984-18.1C1001.793,774.58,973.918,802.235,984.216,809.6Z",
    transform: "translate(239.974 69.325)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M1167,769.39c-23.576,25.311-49.208,48.775-70.918,75.7s-39.727,57.911-45.386,92.035c-.743,4.477-.586,10.273,3.586,12.056,4.151,1.772,8.4-2.044,11.411-5.4,48.729-54.3,125.793-78.789,198.4-71.655,3.88.379,7.865.835,11.618-.216,9.894-2.769,13.991-14.14,18.127-23.545,14.748-33.54,48.666-57.82,85.17-60.972,10.763-.928,21.719-.165,32.28-2.444,16-3.453,29.781-13.63,41.361-25.2,7.188-7.184,13.948-15.393,16.37-25.264s-.641-21.7-9.419-26.826c-3.982-2.324-8.668-3.074-13.247-3.619a197.486,197.486,0,0,0-78.454,6.52c-10.186,2.976-20.244,6.836-28.939,12.918-25.075,17.539-34.805,50.165-56.629,71.619a86.115,86.115,0,0,1-66.983,24.021,6.342,6.342,0,0,1-3.628-1.126c-1.2-1.019-1.5-2.727-1.632-4.3a41.022,41.022,0,0,1,5.5-24.08c5.037-8.546,12.958-14.913,20.255-21.633s14.374-14.423,16.793-24.044-1.447-21.466-10.721-24.986C1234.794,716.247,1217.475,715.2,1167,769.39Z",
    transform: "translate(295.737 2.166)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M1098.133,794.286c-9.523,10.042-18.714,22.274-18.044,36.1,6.495,2.464,12.613-3.971,17.02-9.343,10.227-12.473,24.057-23.5,40.163-24.407,12.215-.688,23.893,4.5,35.858,7.068s26.383,1.605,33.741-8.17a8.532,8.532,0,0,0,2.057-5.467c-.241-3.851-4.328-6.182-8.014-7.328-11.618-3.615-23.151,1.006-34.469-1.968-8.671-2.28-12.951-9.218-20.1-13.55C1128.7,756.536,1109.557,782.24,1098.133,794.286Z",
    transform: "translate(319.965 52.741)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M1232.386,814.12c-14.391,4.386-18.924,23-16.433,37.834s9.476,29.121,8.491,44.132c-.2,2.992-.8,6.142-2.82,8.355-5.171,5.661-14.848,1.157-19.478-4.955-6.881-9.082-9.4-20.722-15.186-30.537a51.942,51.942,0,0,0-90.349,1.5c-4.459,8.172-6.6,18.281-2.865,26.807,5.636,12.853,21.35,16.972,34.593,21.617a141.035,141.035,0,0,1,58.025,38.729c5.745,6.406,10.957,13.445,14.118,21.448,2.943,7.455,4.014,15.493,5.062,23.438l6.847,51.9c1.65,12.511,5.672,27.768,17.994,30.5,12.617,2.794,23.024-10.325,27.116-22.583a90.283,90.283,0,0,0,3.809-40.548c-1.8-13.3-6.534-27.071-2.086-39.729,6.227-17.731,27.036-24.863,40.622-37.846a56.668,56.668,0,0,0,16.978-45.846c-2.594-26.165-22.027-34.965-37.305-52.827C1268.048,832.1,1253.932,807.553,1232.386,814.12Z",
    transform: "translate(329.569 92.172)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M1177.916,899.373c-1.721,4.686-4.644,8.82-6.9,13.27a51.426,51.426,0,0,0-4.366,33.894,6.417,6.417,0,0,0,1.405,3.224,5.282,5.282,0,0,0,3.244,1.347c8.595.98,15.137-7.684,17.98-15.854s4.372-17.51,10.95-23.129c7.322-6.256,18.432-5.674,26.569-10.823,11.495-7.272,12.546-26.372,1.921-34.862-3.915-3.126-9.327-4.494-12.994-7.834-5.574-5.077-3.8-8.239-6.807-14.064-3.588-6.941-7.791-10.027-16.386-8.853C1165.532,839.38,1184.371,881.816,1177.916,899.373Z",
    transform: "translate(389.659 110.46)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M1109.515,866.824c-.71,2.8-1.078,5.855.077,8.5,1.746,4.009,6.463,5.877,10.824,6.193s8.764-.5,13.105.015c12.13,1.443,20.446,12.444,27.863,22.149,5.888,7.7,14.35,15.965,23.764,13.637,8.533-2.108,12.506-14.252,6.868-21a19.044,19.044,0,0,0-4.525-3.775c-8.942-5.647-20.672-7.5-27.114-15.887-8.786-11.451,1.289-39.579-17.751-40.167C1127.967,836.043,1112.721,854.188,1109.515,866.824Z",
    transform: "translate(343.45 111.308)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M1171.674,923.474a97.553,97.553,0,0,0-4.025,41.9,9.782,9.782,0,0,0,1.2,4.165c2.153,3.339,7.542,2.93,10.445.218s3.965-6.807,4.9-10.668l2.607-10.816c1.371-5.685,2.749-11.546,1.866-17.325C1187.482,923.226,1175.892,910.493,1171.674,923.474Z",
    transform: "translate(390.817 177.709)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M1391.719,809.638c-8.278,12.945-14.536,28.972-28.641,35.061-10.3,4.446-22.534,2.137-32.263-3.444s-17.412-14.071-24.718-22.581c-8.328-9.7-16.729-19.9-28.118-25.709s-26.773-5.992-35.655,3.208c-10.2,10.565-7.515,28.418.351,40.82s19.783,21.729,28.307,33.687a76.484,76.484,0,0,1,10.736,65.576c-2.862,9.418-7.529,18.163-11.983,26.942a687.308,687.308,0,0,0-40.091,96.625c-1.881,5.734-3.708,11.646-3.4,17.673s3.17,12.281,8.552,15.013c10.1,5.129,21.488-4.218,27.875-13.572,18.416-26.971,26.145-60.854,48.212-84.927,18.394-20.066,46.084-32.579,56.948-57.539,5.627-12.925,6-27.93,13.223-40.034,10.707-17.938,33.44-24.9,47.126-40.681a52.005,52.005,0,0,0,12.588-33.807c-.013-7.9-1.83-15.927-.04-23.623,2.524-10.85,10.928-36.879-10.892-27.385C1415.489,777.184,1399.91,796.827,1391.719,809.638Z",
    transform: "translate(439.169 56.182)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M1273.148,808.211a6,6,0,0,0-4.334,0,5.514,5.514,0,0,0-2.206,2.613c-4.339,8.853-.417,19.512,4.793,27.88s11.882,16.346,13.445,26.079c4.036,25.148-27.385,46.766-21.246,71.486,8.971-.236,16.6-7.008,21.115-14.761s6.725-16.606,10.226-24.869a85.235,85.235,0,0,1,29.752-36.575c18.792-13.02,42.945-18.145,58.971-35.185,8.355-8.886,15.308-19.6-.728-16.667-15.571,2.849-29.916,12.531-45.458,16.188C1309.87,830.9,1297.455,814.987,1273.148,808.211Z",
    transform: "translate(469.015 87.845)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M1448.6,857.991c-36.031,21.4-51.42,68.292-88.2,88.375-9.83,5.367-21,8.748-29.159,16.417-10.768,10.118-14.171,25.555-18.031,39.818-8.232,30.435-22.517,61.613-49.63,77.7-6.307,3.744-13.553,6.934-17.138,13.334-6.472,11.558,2.529,25.4,11.068,35.526,3.363,3.987,8.172,8.4,13.062,6.587,2.478-.919,4.116-3.235,5.587-5.43a850.949,850.949,0,0,0,44.744-74.861c5.04-9.51,9.99-19.244,17.275-27.167,6.487-7.054,14.6-12.41,22.915-17.17,31.263-17.891,66.811-28.509,95.238-50.63C1468.843,950.752,1525.236,812.477,1448.6,857.991Z",
    transform: "translate(453.872 121.371)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M1264.6,1113.328c-1.592,13.194-5.974,25.9-11.157,38.137-8.031,18.951-18.165,37.2-31.869,52.56-22.521,25.239-51.122,44.148-78.042,64.63-42.923,32.657-83.073,116.618-74.287,132.443,9.2,16.575,60.68-77.643,74.01-88.418,47.146-38.108,92.634-78.6,143.638-111.362,16.041-10.3,32.772-19.961,46.215-33.482,3.766-3.787,7.384-8.132,8.346-13.386,3.1-16.941-22.1-30.971-16.121-47.121,3.68-9.933,16.44-12.176,25.117-18.25a29.615,29.615,0,0,0,12.39-24.638c-.748-26.475-27.43-26.568-45.592-35.3-17.766-8.537-29.475-24.442-42.46-38.58-8.076-8.793-17.577-19.71-29.961-12.284-24,14.392-6.741,38.9,1.89,56.173C1258.854,1058.742,1267.918,1085.84,1264.6,1113.328Z",
    transform: "translate(310.155 224.949)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M1228.248,1082.7c1.919,4.958-.737,12.337,4.014,14.725,10.525,5.287,37.9-45.005,21.951-55.614-9.4-6.255-19.318-2.266-26.059,5.35C1215.431,1061.539,1222.764,1068.547,1228.248,1082.7Z",
    transform: "translate(435.01 276.255)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M1194.545,1029.4c1.391,21.513,9.465,42.719,6.734,64.106-4.4,34.476-40.719,90.967-37.173,96.474s36.813-23.823,45.908-43.972c8.619-19.095,13.661-39.074,16.518-59.766,1.089-7.883.9-17.39,7.286-23.205,4.57-4.161,15.674-2.526,18.868-6.892,5.323-7.279-9.087-15.783-14-19.863-12.88-10.7-23.806-20.478-32.518-34.923C1195.62,1004.977,1193.922,1019.771,1194.545,1029.4Z",
    transform: "translate(388.319 245.78)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M941.746,1240.074c-11.923,13.2-27.056,23.01-40.47,34.691s-25.624,26.27-28.507,43.82c-1.8,10.979,3.09,25.242,14.2,25.9,6.046.358,11.462-3.617,15.761-7.884,9.327-9.249,16.173-20.672,24.714-30.653s19.634-18.87,32.7-20.22c13.864-1.433,27.234,5.812,41.165,6.231,23.2.7,42.908-17.2,65.765-21.232,24.6-4.339,49.372,7.833,74.315,6.456,16.366-.9,32.195-7.8,44.612-18.5,6.206-5.345,11.8-12.016,13.4-20.05s-1.965-17.5-9.592-20.489c-6.966-2.729-14.721.438-21.488,3.629-30.052,14.182-62.192,30.286-94.887,24.342-6.38-1.16-12.684-3.163-19.167-3.061-13.893.216-25.562,9.775-37.591,16.731-3.893,2.253-8.4,4.325-12.745,3.15-7.533-2.037-9.292-11.633-10.783-19.293-2.128-10.932-11.558-40.728-25.7-41.628C957.115,1201.365,949.228,1231.79,941.746,1240.074Z",
    transform: "translate(150.602 409.435)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M872.274,1237.318c-4.679-10.186-10.173-21.2-20.429-25.72-10.562-4.655-24.322.078-29.785,10.244s-1.814,24.253,7.9,30.491c3.234,2.077,7.016,3.377,9.755,6.071,7.6,7.473,3.265,20.059,3.268,30.72.007,17.2,14.9,33.068,32.06,34.17,4.029.26,8.76-.619,10.638-4.194a10.945,10.945,0,0,0,.835-5.77,43.319,43.319,0,0,0-4.038-15.809,11.312,11.312,0,0,1-1.48-4.53c-.065-5.913,8.6-6.89,12.8-11.048,8.657-8.562-3.468-13.719-8.121-18.753C879.245,1256.229,876.193,1245.842,872.274,1237.318Z",
    transform: "translate(107.466 415.788)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M842.822,1162.153a304.852,304.852,0,0,0-23.694-42.885c-3.551-5.36-7.448-10.77-13-14.011s-13.207-3.738-18.053.487c-3.566,3.108-4.929,8.038-5.474,12.736a53.238,53.238,0,0,0,16.384,44.4c9.7,9.011,23.423,15.193,27.566,27.768,3.608,10.943-1.5,22.579-5.153,33.506s-5.238,24.661,3.246,32.454c10.006,9.193,26.655,3.2,36.29-6.375,4.2-4.176,10.565-9.265,15.106-5.461,2.616,2.193,2.625,6.108,3.486,9.41,2.536,9.717,15.431,15,24.059,9.863s10.113-19,2.774-25.853c-12.45-11.627-18.271-24.22-33.213-33.117C857.024,1195.467,850.266,1178.635,842.822,1162.153Z",
    transform: "translate(77.09 328.436)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M823.467,1285.44c-3.708,2.583-5.214,7.255-6.489,11.591-1.019,3.468-2.039,7.184-.961,10.635a15.3,15.3,0,0,0,1.894,3.731c4.007,6.168,9.866,11.533,17.05,13.105,10.149,2.22,21.976-3.145,30.542,2.734,2.159,1.482,3.851,3.557,5.977,5.084,3.575,2.565,8.161,3.4,12.555,3.168,7.844-.418,16.444-5.627,16.638-13.481.169-6.842-6.269-12.324-12.949-13.819-13.214-2.958-28.44,6.663-38.24-4.842C843.426,1296.234,837.74,1275.489,823.467,1285.44Z",
    transform: "translate(104.237 475.317)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M1005.843,1297.193c-8.143,2.228-16.707,2.159-25.13,2.733a162.4,162.4,0,0,0-43.958,9.24c-7.522,2.713-15.028,6.108-20.678,11.769-2.368,2.369-4.439,5.284-4.773,8.617-.646,6.44,5.81,11.943,12.274,12.266s12.522-3.194,17.441-7.4,9.163-9.222,14.5-12.885c12.315-8.459,28.278-8.486,43.106-10.314A159.268,159.268,0,0,0,1048.9,1296.3c10.632-5.191,28.222-32.861,6.389-27.893C1037.9,1272.364,1024.23,1292.162,1005.843,1297.193Z",
    transform: "translate(182.293 463.105)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M1069.819,1116.9c-3.466,3.034-5.53,7.366-6.945,11.749-1.917,5.939-2.244,13.646,2.892,17.19a10.565,10.565,0,0,0,6.653,1.652c11.752-.744,17.788-15.184,28.8-19.354,2.976-1.126,6.184-1.44,9.318-1.99a61.741,61.741,0,0,0,35.043-19.489c18.644-20.852-10.044-24.531-24.231-13.653-6.523,5-11.041,10.832-18.9,14.2C1092.185,1111.6,1078.577,1109.232,1069.819,1116.9Z",
    transform: "translate(304.9 315.661)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M1327.5,1075.51c-.865,2.758-.886,5.7-1.295,8.557a32.066,32.066,0,0,1-14.712,22.432c-3.15,1.939-7.246,4.539-6.324,8.121a5.894,5.894,0,0,0,1.837,2.747c6.208,5.729,16.188,3.675,23.841.1s15.482-8.455,23.848-7.3c2.749.382,5.387,1.415,8.152,1.656,23.147,2.014,24.068-35.181,14.067-48.411C1363.794,1046.051,1333.533,1056.248,1327.5,1075.51Z",
    transform: "translate(503.463 289.134)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M934.325,887.053c-3.032,7.954-.864,16.961-2.633,25.288-2.865,13.5-15.109,22.5-24.976,32.151a118.614,118.614,0,0,0-35.074,76.552c7.582,4.041,17.35,1.017,23.688-4.784s10.068-13.828,13.871-21.531c7.239-14.657,15.438-29.1,26.913-40.742s26.628-20.351,42.946-21.312c12.3-.724,24.393,2.907,36.594,4.662s25.716,1.284,35.37-6.382,12.266-24.554,2.384-31.922c-9.679-7.215-23.336-2.444-33.256-9.291-9.341-6.445-10.505-14.572-22.993-16.026C979.062,871.61,942.633,865.262,934.325,887.053Z",
    transform: "translate(149.981 139.634)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M917.079,903.418c-1.307,2.264-2.595,4.742-2.348,7.346.4,4.238,4.893,7.13,9.147,7.253s8.272-1.792,12.079-3.695c7.4-3.7,15.355-7.616,23.539-6.431,5.356.775,10.131,3.668,14.8,6.4s9.608,5.441,15.011,5.766,11.378-2.444,13.005-7.605c1.832-5.814-2.554-12.01-7.972-14.8-12.1-6.227-27.361-7.9-40.145-13.642-6.137-2.758-13.383-6.956-19.816-4.245C927.633,882.612,920.58,897.356,917.079,903.418Z",
    transform: "translate(185.1 145.895)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M972.985,840.821c-3.237-.4-6.947-.461-9.251,1.846a8.714,8.714,0,0,0-2.153,4.722c-2.186,12.352,8.624,22.8,18.394,30.664l22.189,17.869c4.9,3.949,9.933,7.969,15.879,10.036,5.618,1.954,11.7,2.034,17.644,1.834,9.323-.312,18.873-1.329,27.211-5.514,20.729-10.405,14.489-25.538,20.308-42.342,2.329-6.723,23.545-23.3-.051-26.149-8.918-1.075-11.723,5.641-18.4,10.229a51.73,51.73,0,0,1-29.649,9.243C1013.856,853.531,993.873,843.378,972.985,840.821Z",
    transform: "translate(223.104 109.015)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M1263.33,788.447c7.415-6.542,15.115-13.5,18.445-22.806,5.917-16.553-4.659-35.541-19.917-44.268s-33.788-9.339-51.315-8a268.771,268.771,0,0,0-91.349,23.652c-19.131,8.778-37.314,19.846-57.368,26.241-34.312,10.944-71.421,7.433-107.056,2.213-22.679-3.321-48.125-6.652-66.508,7.039-13.779,10.26-19.955,27.7-24.055,44.386-5.961,24.26-8.243,52.516,7.7,71.749,11.386,13.731,29.527,19.589,46.846,23.863q19.137,4.72,38.605,7.942c3.515.581,7.321,1.084,10.48-.567,2.366-1.236,3.994-3.5,5.463-5.728,20.064-30.46,26.646-69,50.276-96.783,12.119-14.249,28-24.741,44.014-34.4,16.751-10.1,34.057-19.581,52.707-25.479a150.468,150.468,0,0,1,58.338-6.4c10.22.9,22.145,3.62,30.235,10.394,13.634,11.413,7.776,19.992,7.862,35.159C1216.936,832.545,1250.6,799.675,1263.33,788.447Z",
    transform: "translate(140.253 10.454)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    d: "M821.46,882.744c-14.6-17.459-22.9-39.669-38.469-56.268-4.279-4.563-9.272-8.759-15.282-10.5-15.369-4.443-30.5,8.644-37.914,22.824-10.979,21-12.642,45.775-9.966,69.32s9.407,46.409,14.414,69.569c11.881,54.951-6.972,159.787,6.322,167.683s28.5-19.828,36.724-35.668c31.853-61.369,69.422-119.894,113.59-173.095,8.2-9.884,40.2-38.738,39.023-52.2-1.01-11.484-16.662-11.062-25.3-7.025-15.318,7.159-17.971,25.357-37.434,27.5C849.822,906.8,832.152,895.528,821.46,882.744Z",
    transform: "translate(25.246 93.865)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M753.032,921.375c-.171,4.855.08,10.512,4,13.388a7.179,7.179,0,0,0,2.008,1.035c4.3,1.42,9.677-1.2,12.083-5.307,2.8-4.777,2.618-10.685,2.024-16.188-.655-6.089-3.764-18.555-13-16.763C751.236,899.266,753.284,914.225,753.032,921.375Z",
    transform: "translate(53.21 160.961)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M750,1237.686c2.418,2.591,5.085,5.136,8.441,6.28s7.56.5,9.634-2.375a8.983,8.983,0,0,0,1.487-4.953c.539-14.9-19.5-22.02-24.513-36.06-1.941-5.434-1.409-11.389-1.153-17.156,1.019-22.933-20.362-27.715-21.493-4.058C721.452,1199.246,737.134,1223.9,750,1237.686Z",
    transform: "translate(28.226 378.241)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M1281.863,1334.928c-21.749,24.912-45.321,49.815-55.75,81.2-3.488,10.492-3.034,25.642,7.66,28.447,9.223,2.418,17.045-7.1,20.812-15.865,8.274-19.238,10.823-41.273,23.416-58.005,14.427-19.169,61.124-35.334,62.688-62.058.643-10.968-11.168-22.759-22.592-18.864C1305.875,1293.948,1290.814,1324.678,1281.863,1334.928Z",
    transform: "translate(437.506 480.4)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M900.17,776.96A203.5,203.5,0,0,0,886.353,799.1c-1.8,3.339-3.542,6.876-3.624,10.669s1.981,7.892,5.618,8.965c6.293,1.859,10.963-5.43,15.227-10.42,12.019-14.056,44.109-1.071,40.735-21.355C941.219,768.388,910.216,762.951,900.17,776.96Z",
    transform: "translate(159.021 56.319)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M790.538,764.311c-14.042.715-31.058,2.716-36.77,15.563-3.23,7.261-1.492,15.667.429,23.38.639,2.564,1.334,5.211,2.99,7.268,3.039,3.775,8.646,4.583,13.327,3.328s8.7-4.172,12.738-6.854a161.81,161.81,0,0,1,111.506-25.114c34.97,5.051,34.362-33.376.933-31.944C860.594,751.444,825.97,762.5,790.538,764.311Z",
    transform: "translate(52.375 40.687)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M789.6,888.1c-8.018-11.135-13.094-24.066-18.194-36.8-1.914-4.78-3.913-9.67-7.406-13.452s-8.855-6.278-13.833-4.966c-6.18,1.629-9.554,8.185-11.631,14.227a110.427,110.427,0,0,0-4.063,56.079c2.322,12.317,6.745,24.188,8.642,36.577,2.357,15.375.779,31.245,4.185,46.422,2.066,9.2,5.913,17.9,8.684,26.915,3.967,12.911-3.411,38.651,5.124,40s15.591-11.495,20.155-20.262c16.689-32.06,33.08-64.712,56.4-92.324,2.859-3.386,5.879-6.79,7.41-10.948,5.893-16.019-13.539-14.737-23.278-17.631C808.792,908.069,797.457,899.018,789.6,888.1Z",
    transform: "translate(36.564 108.082)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M745.7,852.787c-1.017-1.155-2.228-2.4-3.766-2.409-2.529-.009-3.707,3.147-3.829,5.672-.483,10.073,4.479,19.512,9.3,28.371,3.786,6.952,7.669,14.035,13.472,19.416,7.357,6.828,17.127,10.318,26.64,13.517,8.257,2.778,39.624,16.282,41.792-1.919.9-7.515-9.129-9.454-14.748-11.438-11.233-3.964-23.031-6.839-33.13-13.441C767.279,881.307,756.752,865.359,745.7,852.787Z",
    transform: "translate(41.036 122.638)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M1026.006,828.549a81.355,81.355,0,0,1-47.077,48.677c-11.424,4.381-24.2,6.338-33.631,14.138-5.449,4.51-9.294,10.614-13.047,16.609L843.185,1050.29c-3.2,5.109-6.423,11.711-3.159,16.774,11.751-2.705,19.189-13.955,25.409-24.286q21.9-36.369,43.794-72.735c6.7-11.131,13.445-22.319,21.907-32.178a117.131,117.131,0,0,1,55.543-35.858c10.405-3.052,21.275-4.662,31.26-8.893s19.349-11.785,22.176-22.252c3.023-11.184-1.917-23.329.921-34.56,1.968-7.787,7.489-14.3,9.507-22.074,1.8-6.93-3.893-23.385-13.891-19.412C1029.37,797.707,1028.4,821.634,1026.006,828.549Z",
    transform: "translate(123.083 76.823)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M798.333,795.876c-6.986,3.475-14.049,7.649-18.14,14.294-3.795,6.162-4.55,13.675-4.924,20.9-.986,19.035.3,39.13,10.369,55.314,1.42,2.28,3.793,4.75,6.34,3.9,2.184-.73,2.892-3.413,3.232-5.69,2.177-14.619,2.84-29.609,7.562-43.615,9.657-28.647,37.34-49.922,67.274-52.92,4.957-.5,27.793-1.058,18.073-9.746-5.962-5.333-26.521-.991-33.444-.076A180.263,180.263,0,0,0,798.333,795.876Z",
    transform: "translate(71.154 61.736)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M894.955,825.977c-3.032-2.409-6.037-4.942-9.568-6.529-7.673-3.448-16.854-1.883-24.276,2.081s-13.437,10.062-19.329,16.066c-5.993,6.106-12.232,12.646-14.213,20.97,5.4,5.8,15.137,4.243,21.969.225s12.6-10.015,20.132-12.49c4.577-1.5,9.479-1.587,14.294-1.656,8.942-.129,17.975-.249,26.711,1.656,10.309,2.246,21.747,10.109,32.333,9.955,8.849-.127,8.8-1.385,3.611-6.482-5.009-4.915-15.336-6.387-21.784-8.368A87.417,87.417,0,0,1,894.955,825.977Z",
    transform: "translate(114.034 95.859)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M806.584,833.391a20.081,20.081,0,0,0,15.4-3.007c2.344-1.6,4.325-3.695,6.667-5.3,10.14-6.948,20.587-1.013,30.963-4.129,10.8-3.245,8.13-16.5-1.779-20.562C843.179,794.386,811.875,820.507,806.584,833.391Z",
    transform: "translate(96.919 81.148)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M742.874,757.259c-19.3,14.937-31.4,41.113-24.109,64.4,2.355,7.52,7.675,15.166,15.5,16.074,4.283.5,8.506-1.135,12.439-2.9,5.523-2.478,11.373-5.815,13.33-11.544,1.943-5.679-.563-11.785-2.349-17.515a74.042,74.042,0,0,1-3.341-20.742c-.111-6.449.692-13.114,3.893-18.714,7.246-12.669,23.833-15.927,38.393-16.951,21.419-1.507,13.813-14.4-3.275-12.246C775.561,739.368,757.09,746.252,742.874,757.259Z",
    transform: "translate(23.543 30.067)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M1213.555,1314.428c-4.412,6.745-8.864,13.673-10.8,21.5-3.036,12.288.47,25.375-1.817,37.825-2.446,13.294-11.155,24.423-19.255,35.243a631.091,631.091,0,0,0-38.867,58.434c-2.545,4.33-5.1,8.889-5.434,13.9s2.259,10.589,7.072,12.021c5.8,1.727,11.436-2.979,15.246-7.678a89.389,89.389,0,0,0,14.723-26.2c3.584-10.046,5.373-20.747,9.969-30.373,6.651-13.924,18.628-24.511,27.16-37.371a86.969,86.969,0,0,0,14.336-50.568c-.181-5.45-.868-11.019.576-16.281,3.386-12.335,35.931-37.832,23.6-51.719C1241.085,1263.032,1218.835,1306.354,1213.555,1314.428Z",
    transform: "translate(366.702 466.219)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M1335.551,1187.667c-8.952,5.668-18.2,11.053-25.929,18.3s-13.949,16.7-15.017,27.24c9.447,2.564,17.7-6.32,23.935-13.866a227.27,227.27,0,0,1,69.952-56.616c8.975-4.677,18.329-8.793,26.43-14.859,7.665-5.739,15.456-14.376,16.5-24.24-18.721-8.216-31.345,14.209-44.1,25.368A419.316,419.316,0,0,1,1335.551,1187.667Z",
    transform: "translate(494.955 344.056)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M1423.728,1243.353c-28.781,28.34-68.136,42.56-103.245,62.533-7.368,4.192-14.659,8.722-20.585,14.783-4.739,4.846-8.493,10.556-12.063,16.319q-9.48,15.3-17.524,31.427c-2.959,5.933-5.479,13.88-.735,18.51,5.325,5.2,14.189,1.017,20.014-3.613,19.723-15.674,36.158-35.126,55.591-51.162,25.409-20.969,55.318-35.606,83.3-52.994,12.43-7.724,24.867-16.379,32.6-28.8,10.756-17.268,11.061-39.626,22.4-56.518,6.556-9.766,16.262-16.878,25.46-24.211,12.181-9.708,27.6-23.59,25.858-40.955-1.411-14.082-14.576-16.555-25.055-8.967-24.431,17.686-38.417,55.316-53.566,80.4C1446.846,1215.556,1436.641,1230.636,1423.728,1243.353Z",
    transform: "translate(472.384 338.868)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M1325.724,1309.211c-7.332,4.188-15.7,6.1-23.732,8.709a138.421,138.421,0,0,0-34.348,16.7c-7.933,5.327-15.42,11.6-20.683,19.573-5.65,8.557-8.464,18.614-11.591,28.38a387.719,387.719,0,0,1-38.614,84.255c-10.395,16.965-22.5,34.348-23.086,54.234-.114,3.911.388,8.19,3.15,10.961,5.49,5.5,14.874,1.256,20.772-3.807a103.028,103.028,0,0,0,25.192-32.472c2.925-5.926,5.361-12.268,9.873-17.1s11.885-7.791,17.848-4.942a22.674,22.674,0,0,1,6.03,4.82c8.666,8.717,17.608,17.621,28.836,22.623s25.42,5.3,34.921-2.5c7.941-6.518,11.084-17.141,13.034-27.229,3.579-18.514,4.608-37.672,11.081-55.384a95.049,95.049,0,0,1,27.9-39.86c9.4-7.914,20.287-13.957,29.4-22.2,22.152-20.059,18.52-55.917-5.22-74.2C1369.576,1259.064,1346.209,1297.5,1325.724,1309.211Z",
    transform: "translate(396.306 467.952)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M1366.232,1356.577c-6.609,12.092-13.091,24.491-15.961,37.968-3.945,18.532-1.055,38.882-9.964,55.6-4.608,8.648-12.355,16.415-12.413,26.216a35.8,35.8,0,0,0,36.483-8.684c7.081-7.281,10.648-17.23,16.562-25.486s16.244-15.153,25.809-11.74c2.535.906,4.846,2.489,7.5,2.912,6.917,1.1,12.651-6.409,12.778-13.414s-3.426-13.455-6.228-19.877c-5.314-12.175-7.987-25.823-6.718-39.1.955-9.99,8.4-21.021,1.066-29.945C1396.347,1308.153,1373.973,1342.414,1366.232,1356.577Z",
    transform: "translate(522.104 508.41)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M1290.781,1424.889c-.866,3.058-1.676,6.224-1.285,9.378s2.251,6.324,5.254,7.359,6.442-.325,8.662-2.605,3.457-5.323,4.5-8.33c6.919-19.948,7.823-42.222,18.9-60.2,2.887-4.686,6.418-8.982,8.915-13.889,4.615-9.069,2.943-16.669-5.906-9.4-6.77,5.563-12.213,17.241-16.578,24.768A231.392,231.392,0,0,0,1290.781,1424.889Z",
    transform: "translate(490.704 525.485)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M1321.114,981.326c-8.728,6.38-18.094,14.36-18.661,25.157-.114,2.179.223,4.535,1.7,6.142,1.868,2.033,5.005,2.289,7.725,1.808a23.847,23.847,0,0,0,11.309-5.718c4.185-3.644,7.642-8.544,12.922-10.254,6.7-2.166,13.82,1.592,19.387,5.9s10.973,9.492,17.895,10.768a3.42,3.42,0,0,0,2.929-.441,3.356,3.356,0,0,0,.839-1.51c2.625-8.041-1.91-17.733-9.766-20.869-3.822-1.525-8.75-2.1-10.453-5.843-3.468-7.622,2.337-17.6-9.637-18.607C1338.549,967.127,1327.592,976.591,1321.114,981.326Z",
    transform: "translate(501.338 218.425)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M1351.505,914.633c-11.23,5.877-22.966,11.2-32.465,19.587s-16.607,20.669-15.182,33.262a11.193,11.193,0,0,0,1.567,5.024c3.377,5.051,11.38,3.517,16.255-.111,9.3-6.923,13.948-18.6,22.711-26.2,8.541-7.4,20.064-10.177,29.885-15.767,10.529-5.993,41.14-39.724,26.555-52.577-9.488-8.361-15.347,7.453-19.011,12.782C1374.313,901.561,1363.05,908.591,1351.505,914.633Z",
    transform: "translate(502.352 143.098)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M1381.928,859.347c-3.562,11.073-13.679,21.495-9.946,32.514,13.218,3.876,28.768-4.724,32.512-17.98,2.266-8.018.6-16.646,2.061-24.85,2.09-11.756,10.292-21.442,14.467-32.63a50.377,50.377,0,0,0-4.935-44.412c-4.7-7.193-11.28-13.2-14.759-21.056-2.13-4.81-3.059-10.244-6.251-14.425-4.4-5.77-12.213-7.883-19.47-7.854-17.869.071-35.072,11.812-41.9,28.325-4.194,10.142-2.491,23.634,10.322,24.943,10.352,1.057,18.844-8.308,26.6,2.306,5.572,7.624,4.882,21.656,6.778,30.568C1380.443,829.063,1386.62,844.762,1381.928,859.347Z",
    transform: "translate(525.177 23.359)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M1321.108,738.307c-8.014,10.135-17.971,18.563-26.45,28.311s-15.663,21.442-16.375,34.344,6.767,26.88,19.262,30.17a11.943,11.943,0,0,0,6.3.2c4.312-1.236,6.8-5.728,8.152-10,5.857-18.49-.443-40.29,9.668-56.841,4.078-6.674,10.38-11.615,16.094-16.956s11.157-11.625,12.593-19.313c1.353-7.25-2.918-19.683-12.23-15.876C1331.208,715.169,1325.9,732.249,1321.108,738.307Z",
    transform: "translate(481.604 9.477)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M1256.593,716.1c-8.363-.249-16.95.134-24.681,3.333s-14.519,9.683-16.124,17.893c-.683,3.488-.334,7.344,1.774,10.205,3.7,5.028,11.35,5.207,17.136,2.865s10.623-6.582,16.313-9.147a31.356,31.356,0,0,1,19.527-2.01c3.29.73,6.483,2,9.848,2.224,13.1.879,10.576-14.588,3.533-20.743C1276.917,714.6,1265.331,716.361,1256.593,716.1Z",
    transform: "translate(430.411 13.069)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M1105.641,744.17c-.6,2.333-.71,5.244,1.213,6.692a5.1,5.1,0,0,0,3.252.844c6.983-.222,11.193-7.446,15.738-12.755,7.8-9.116,19.358-13.958,30.511-18.383a18.628,18.628,0,0,0,6.2-3.428c1.718-1.641,2.772-4.214,1.952-6.444-.938-2.556-3.86-3.744-6.529-4.288C1136.872,702.1,1110.747,724.359,1105.641,744.17Z",
    transform: "translate(340.516 4.775)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M1014.113,906.713c-8.541,2.9-15.227,9.49-21.595,15.878-3.168,3.177-6.473,6.6-7.482,10.968a12.079,12.079,0,0,0,19.681,11.84c2.2-1.91,3.631-4.534,5.423-6.83a26.235,26.235,0,0,1,13.741-9.116c6.471-1.743,13.889-1.117,19.222-5.176,2.958-2.251,5.044-6.531,8.513-8.029,3.355-1.449,9.813,1.093,12.3-.8,4.265-3.254,1.126-4.188-2.6-7.273C1050.694,899.367,1025.545,902.829,1014.113,906.713Z",
    transform: "translate(242.234 165.276)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M841.511,1005.538c-2.82,10.055-1.133,22.79,7.961,27.92,4.822,2.722,10.658,2.711,16.2,2.627,3.989-.06,8.635-.459,10.832-3.791,1.458-2.208,1.347-5.06,1.184-7.7-.363-5.883-1.643-11.52,1.068-16.678,2.2-4.189,6.925-4.6,8.154-10.264,1.549-7.137-2.631-13-8.795-16.126C860.467,972.585,845.847,990.08,841.511,1005.538Z",
    transform: "translate(124.39 227.622)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M1089.9,1384.041c-.038,4.269.714,9.027,4.074,11.658,4.379,3.429,11.266,1.305,14.7-3.074s4.236-10.217,4.632-15.765c.35-4.9.47-9.973,2.268-14.614,1.541-3.983,6.583-7.918,7.284-11.985,1.131-6.562.283-7.528-7-7.146C1098.383,1344.032,1090.026,1370.13,1089.9,1384.041Z",
    transform: "translate(327.992 524.462)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M821.917,720.514c-9.683.443-19.777,1.129-28.133,6.041S779.515,741.956,782.99,751c2.8,7.293,128.981,1,134.386-5.5C946.515,710.5,832.473,720.031,821.917,720.514Z",
    transform: "translate(76.848 15.463)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M688.393,888.421c-2.749,28.16,3.261,57.864,20.449,80.339,2.386,3.121,6.338,6.391,9.786,4.508,2.237-1.222,2.949-4.047,3.348-6.563,5.193-32.7-4.6-66.437.843-99.1,1.777-10.674,5.165-21.087,6.035-31.871,1.708-21.168-8.533-27.214-21.43-10.937C695.272,840.134,690.237,869.524,688.393,888.421Z",
    transform: "translate(0 94.202)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M1368.68,984.86c2.083,7.478,7.609,13.426,12.951,19.058l24.347,25.667c3.511,3.7,8.428,7.74,13.125,5.748a8.837,8.837,0,0,0,4.114-4.094c3.675-6.825,1.267-15.289-2.094-22.276-7.595-15.785-.436-43.2-16.329-52.349C1386.678,946.182,1363.186,965.123,1368.68,984.86Z",
    transform: "translate(554.708 206.868)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M1184.118,729.056c-7.212,9.93-14.625,21.789-11.46,33.647,3.5.93,7.1-1.57,9.027-4.639s2.743-6.7,4.33-9.959c5.064-10.4,16.791-15.322,27.034-20.705,10.017-5.267,26.891-21.865,6.155-27.089C1206.467,697.1,1190.121,720.8,1184.118,729.056Z",
    transform: "translate(394.88 0)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M973.625,1432.942a342.18,342.18,0,0,1-32.679,17.283c-4.455,2.057-9.784,5.467-8.909,10.3,1.013,5.583,8.822,6.1,14.354,4.839,29.24-6.671,57.381-23.821,87.037-19.347,5.252.792,10.507,2.268,15.789,1.7s10.776-3.9,11.707-9.133c.9-5.029-2.749-9.9-7.159-12.479s-9.554-3.526-14.367-5.247c-13.753-4.915-31.089-40.908-42.414-36.387C984.077,1389.62,991.1,1422.459,973.625,1432.942Z",
    transform: "translate(199.162 557.931)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadow);
export default __webpack_public_path__ + "static/media/shadow.26cf41c4183acce25504a84f574b4642.svg";
export { ForwardRef as ReactComponent };